import { render, staticRenderFns } from "./teacherPatients.vue?vue&type=template&id=c3b34310&scoped=true"
import script from "./teacherPatients.vue?vue&type=script&lang=js"
export * from "./teacherPatients.vue?vue&type=script&lang=js"
import style0 from "./teacherPatients.vue?vue&type=style&index=0&id=c3b34310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b34310",
  null
  
)

export default component.exports